// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ju-0";